import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChooseFromNormativeDbService {
  normativeAgentChosen$$ = new BehaviorSubject<boolean>(false);

  get agentChosen$() {
    return this.normativeAgentChosen$$.asObservable();
  }

  chooseAgent() {
    this.normativeAgentChosen$$.next(true);
  }

  clearChoice() {
    this.normativeAgentChosen$$.next(false);
  }
}
